import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ExportApi, ExportRequest } from '../export-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class ExportApiImpl extends GuestAwareHttpService implements ExportApi {
    async exportReport(request: ExportRequest): Promise<Blob> {
        // 对于Blob响应，我们需要直接使用原始的post方法并手动解析路径
        const resolvedUrl = await this.resolveApiPath('cc_compare/export');

        const res = await this.post<Blob>({
            url: resolvedUrl,
            data: request,
            headers: {
                ...this.getDefaultHeaders(),
            },
            responseType: 'blob',
        });
        return res;
    }

    private async resolveApiPath(basePath: string): Promise<string> {
        const { resolveApiPath } = await import('@/utils/api-path-resolver');
        return resolveApiPath(basePath);
    }
}
